export default {
	properties: [
		{
			text: 'Nombre',
			key: 'nombre',
			type: 'text',
			value: '',
			is_title: true,
		},
	],
	singular_model_name_spanish: 'Permiso',
	plural_model_name_spanish: 'Permisos',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}